import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-smart-link',
  templateUrl: './smart-link.component.html',
  styleUrls: ['./smart-link.component.scss'],
})
export class SmartLinkComponent implements OnInit, OnDestroy {
  @Input() route: string | any[] | null | undefined;
  @Input() customClass: string = '';
  @Input() activeClass: string = '';

  @Input() activeOptions: { exact: boolean } = { exact: false };

  @Output() onSmartClick = new EventEmitter<MouseEvent>();

  isActive: boolean = false;
  private routerSub!: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.checkIfIsActive();

    this.routerSub = this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd,
        ),
      )
      .subscribe(() => {
        this.checkIfIsActive();
      });
  }

  ngOnDestroy(): void {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  handleSmartClick(event: MouseEvent) {
    this.onSmartClick.emit(event);
  }

  private checkIfIsActive() {
    if (!this.route || !this.activeClass) {
      this.isActive = false;
      return;
    }

    const commands = Array.isArray(this.route) ? this.route : [this.route];
    const urlTree = this.router.createUrlTree(commands);

    this.isActive = this.router.isActive(urlTree, this.activeOptions.exact);
  }
}
